import { Pipe, PipeTransform } from "@angular/core";

import { MedTableColumnConfig } from "../types";
import { MedTableSettingsLocal } from "../types.local";

@Pipe({
  name: "getCellLeft",
})
export class GetCellLeftPipe implements PipeTransform {
  transform(column: MedTableColumnConfig, columns: MedTableColumnConfig[], { stickyLeft }: MedTableSettingsLocal): string {
    const index = columns.findIndex(item => item.key === column.key);

    if (!column.fixed || index === 0) {
      return stickyLeft;
    }

    const list = columns
      .filter((item, i) => i < index && item.fixed)
      .map(({ minWidth }) => minWidth)
      .filter(Boolean)
      .join(" + ");

    return list ? `calc(${list} + ${stickyLeft})` : stickyLeft;
  }
}
